import { Briefcase, AlertTriangle, CheckCircle, Wallet, Share2, Copy, Check } from "lucide-react";
import { useState } from "react";

export function PartnerBadge() {
  return (
    <span className="px-3 py-1.5 rounded-full bg-cipher-green/20 text-cipher-green text-xs font-medium border border-cipher-green/30 flex items-center gap-1.5" data-testid="partner-badge">
      <Briefcase className="w-3 h-3" />
      Partner Lens
    </span>
  );
}

export function AgentBrief({ brief, clientType }) {
  if (!brief) return null;
  
  const typeLabels = {
    vendor: "Vendor Assessment",
    buyer: "Buyer Assessment",
    landlord: "Landlord Assessment",
    tenant: "Tenant Assessment",
  };

  return (
    <div className="mb-6 bg-cipher-green/[0.08] border border-cipher-green/20 rounded-2xl p-5" data-testid="agent-brief">
      <div className="flex items-center gap-2 mb-3">
        <Briefcase className="w-4 h-4 text-cipher-green" />
        <h3 className="text-xs font-semibold text-cipher-green uppercase tracking-wider">
          {typeLabels[clientType] || "Agent Brief"}
        </h3>
      </div>
      <p className="text-sm text-white/80 leading-relaxed">{brief}</p>
    </div>
  );
}

export function BudgetIntegrity({ budgetCheck }) {
  if (!budgetCheck) return null;
  
  const isAligned = budgetCheck.status === "aligned";
  
  return (
    <div
      className={`mb-4 flex items-start gap-3 px-4 py-3 rounded-xl border ${
        isAligned
          ? "bg-cipher-green/[0.06] border-cipher-green/20"
          : "bg-amber-500/[0.06] border-amber-500/15"
      }`}
      data-testid="budget-integrity"
    >
      {isAligned ? (
        <CheckCircle className="w-4 h-4 text-cipher-green mt-0.5 flex-shrink-0" />
      ) : (
        <AlertTriangle className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
      )}
      <div>
        <p className="text-xs font-semibold text-white/70 mb-0.5 flex items-center gap-1.5">
          <Wallet className="w-3 h-3" />
          Budget Integrity
        </p>
        <p className={`text-xs leading-relaxed ${isAligned ? "text-white/50" : "text-amber-300/70"}`}>
          {budgetCheck.message}
        </p>
      </div>
    </div>
  );
}

export function ShareWithClient({ submissionId }) {
  const [copied, setCopied] = useState(false);
  
  const shareUrl = `${window.location.origin}/hippo/${submissionId}`;
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.warn("Clipboard access not available");
    }
  };

  return (
    <div className="mb-4 bg-white/5 border border-white/10 rounded-xl p-4" data-testid="share-with-client">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Share2 className="w-4 h-4 text-white/40" />
          <span className="text-xs font-medium text-white/60">Share with client</span>
        </div>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/15 border border-white/10 text-xs text-white/70 transition-colors"
          data-testid="copy-client-link"
        >
          {copied ? (
            <>
              <Check className="w-3 h-3 text-cipher-green" />
              <span className="text-cipher-green">Copied</span>
            </>
          ) : (
            <>
              <Copy className="w-3 h-3" />
              Copy link
            </>
          )}
        </button>
      </div>
    </div>
  );
}
